export const ROLES = {
    Student: 'Student',
    Employee: 'Employee',
    Facilitator: 'Facilitator'
}